// ---------------------------------------------------------------------------
// SAM 3 — Backend proxy service
// Llama al endpoint del backend en /api/segment (el backend llama a Roboflow).
// ---------------------------------------------------------------------------

import axios from 'axios';
import { Sam3TextPrompt } from '../models/sam3Model';

const loadAbort = () => new AbortController();

export const segmentWithSam3Endpoint = (
  imageBase64: string,
  prompts: Sam3TextPrompt[],
  threshold: number = 0.4,
  token: string = '',
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `http://localhost:3001/api/segment`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          imageBase64,
          prompts,
          format: 'polygon',
          threshold,
        }),
        signal: controller.signal,
      }),
    controller,
  };
};
